import {
    NCoreUIKitTheme
} from "../../../core/hooks";
import type {
    INCoreUIKitIconProps
} from "../../../types";
import {
    Path,
    Defs,
    Svg,
    G
} from "react-native-svg";

const NIBGATCommunityIcon = ({
    customColor = "#00c2a9",
    size = 30,
    color,
    style,
    ...props
}: INCoreUIKitIconProps) => {
    const {
        colors
    } = NCoreUIKitTheme.useContext();

    const pathScale = 3543 / size;

    const strokeWidth = (size * 2.362) / 3543;

    return <Svg
        fillRule="evenodd"
        clipRule="evenodd"
        height={size}
        width={size}
        style={{
            ...style
        }}
        {...props}
    >
        <Defs></Defs>
        <G
            id="Layer_x0020_1"
        >
            <Path
                d="m1263 780 127-220 127-221h509l127 221 127 220-127 220-127 221h-509l-127-221zM2121 1276l128-221 127-220h509l127 220 127 221-127 220-127 220h-509l-127-220zM2121 2267l128-220 127-220h509l127 220 127 220-127 221-127 220h-509l-127-220zM1263 2763l127-220 127-221h509l127 221 127 220-127 220-127 221h-509l-127-221zM404 2267l127-220 127-220h509l127 220 128 220-128 221-127 220H658l-127-220zM404 1276l127-221 127-220h509l127 220 128 221-128 220-127 220H658l-127-220z"
                transform={[
                    {
                        scale: 1 / pathScale
                    }
                ]}
            />
            <Path
                d="m1263 1772 127-221 127-220h509l127 220 127 221-127 220-127 220h-509l-127-220-127-220zm599-215h0c9-5 21-2 26 6l114 199c2 3 3 6 3 10 0 3-1 6-3 9l-113 197c-2 4-5 7-9 9h0c-9 4-20 1-25-8l-185-368-92 161 109 189c5 9 2 20-6 25h0c-9 5-21 2-26-6l-114-199c-2-3-3-6-3-10 0-3 1-6 3-9l113-197c2-4 5-7 9-9h0c9-4 20-1 25 8l185 368 92-160-109-190c-5-9-2-20 6-25z"
                stroke={color ? colors.content.icon[color] : customColor}
                fill={color ? colors.content.icon[color] : customColor}
                transform={[
                    {
                        scale: 1 / pathScale
                    }
                ]}
                strokeWidth={strokeWidth}
                strokeLinejoin="round"
                strokeLinecap="round"
            />
        </G>
    </Svg>;
};
export default NIBGATCommunityIcon;
